module.exports = __webpack_public_path__ + "img/service2.9a6f778.png";